!function(){function t(e){var t=e.querySelector(".money");t&&(t=t.outerHTML,e.innerHTML!==t)&&(e=e.innerHTML=t,t=document.querySelector("button.checkout__button.bold_clone"))&&(t=t.querySelector(".cart__footer__value .money"))&&(t.innerHTML=e)}var o=new MutationObserver(function(e){e.forEach(function(e){t(e.target)})}),e=document.querySelectorAll(".cart__footer__value");e.forEach(function(e){o.observe(e,{childList:!0,subtree:!0,characterData:!0})}),e.forEach(t),document.getElementById("drawer-cart-cart-form-terms-checkbox").addEventListener("change",function(){document.querySelectorAll("#drawer-cart .drawer__content .drawer__bottom #cart-form button.checkout__button").forEach(function(e){this.checked?(console.log("checked"),e.disabled=!1):(console.log("unchecked"),e.disabled=!0)},this)}),document.addEventListener("DOMContentLoaded",function(){var t=document.querySelector(".selector-wrapper.selector-wrapper--color .radio__legend"),o=document.querySelector("form .product__submit .product__submit__buttons"),n=document.querySelectorAll('input[name="options[Colour]"]'),r=document.querySelector("button.select-popout__toggle"),e=document.querySelector(".product__block__buttons"),a=document.querySelector(".radio__inputs.radio__inputs--swatch"),c=(t&&(t.style.display="none"),o&&(o.style.pointerEvents="none",o.style.opacity="0.5"),!1),u=r?r.innerText.trim():"";function l(){return!r||"Please select"!==r.innerText.trim()}function i(e,t){var o=e.parentNode.querySelector(".error-message");!o&&c&&((o=document.createElement("p")).classList.add("error-message"),o.style.color="red",o.style.marginTop="10px",o.innerText=t,e.parentNode.appendChild(o))}function s(e){e=e.parentNode.querySelector(".error-message");e&&e.remove()}function d(){var e=!0;return a&&0<n.length&&(0<n.length&&Array.prototype.some.call(n,function(e){return e.checked})?s(a):(e=!1,i(a,"Please select a colour option"))),r&&(l()?s(r):(e=!1,i(r,"Please make a selection"))),o&&(e?(o.style.pointerEvents="auto",o.style.opacity="1"):(o.style.pointerEvents="none",o.style.opacity="0.5")),e}0<n.length&&n.forEach(function(e){e.addEventListener("click",function(){t&&(t.style.display="block"),d()})}),r&&setInterval(function(){var e=r.innerText.trim();e!==u&&(u=e,l())&&(s(r),d())},500),e&&e.addEventListener("click",function(e){c=!0,d()||e.preventDefault()}),d()}),document.addEventListener("DOMContentLoaded",function(){var e=document.getElementById("headerVideoLink"),t=document.getElementById("headerPopup"),o=document.getElementById("sustainable-video");e&&(e.addEventListener("click",function(){t.classList.add("show-video"),t.classList.remove("hide"),o.play()}),t.addEventListener("click",function(e){o.contains(e.target)||(t.classList.remove("show-video"),t.classList.add("hide"),o.pause())}))}),document.addEventListener("DOMContentLoaded",function(){var a=[{value:"black",keys:["Black","Nappa Black"]},{value:"brown",keys:["Chocolate","Chestnut","Bomber","Chestnut Bomber","Nappa Bronze"]},{value:"beige",keys:["Sand"]},{value:"grey",keys:["Slate","Cloud"]},{value:"blue",keys:["Navy","Country Blue","Powderpuff","Aqua","Lagoon","Denim"]},{value:"pink",keys:["Orchid","Posy","Fuschia"]},{value:"purple",keys:["Raisin","Lilac"]},{value:"green",keys:["Khaki","Aqua"]},{value:"red",keys:["Jester","Rust"]},{value:"neutral",keys:["Black","Chocolate","Chestnut","Sand","Khaki"]},{value:"pastel",keys:["Cloud","Posy","Sherbet","Powderpuff","Wattle"]},{value:"bright",keys:["Country Blue","Aqua","Orchid","Fuschia","Lilac"]},{value:"leather",keys:["Nappa Black","Nappa Bronze","Bomber","Chestnut Bomber"]},{value:"pattern",keys:["Aztec","Leopard","Calf"]},{value:"limited-edition",keys:["Cloud","Posy","Sherbet","Powderpuff","Wattle","Lagoon","Rust"]}];function n(r){r.querySelectorAll("input[data-swatch-input]").forEach(function(e){e.addEventListener("change",function(){var t,e,o,n;t=this.value,e=a.find(function(e){return e.keys.includes(t)}),o=e?e.keys:[t],e=r.querySelectorAll(".product__media"),n=!1,e.forEach(function(e){var t;n||(t=e.getAttribute("data-media-src-placeholder")||"",o.some(function(e){return t.toLowerCase().includes(e.toLowerCase())})&&(e.scrollIntoView({behavior:"smooth",block:"center"}),n=!0))}),n||r.scrollIntoView({behavior:"smooth",block:"start"})})})}var r=document.querySelector("[data-product-quickview-ajax]"),e=new MutationObserver(function(e){for(var t=0;t<e.length;t++){var o=e[t];"childList"===o.type&&0<o.addedNodes.length&&n(r)}});r&&e.observe(r,{childList:!0,subtree:!0}),r&&n(r)})}();! function() {
	function t(e) {
		var t = e.querySelector(".money");
		t && (t = t.outerHTML, e.innerHTML !== t) && (e = e.innerHTML = t, t = document.querySelector("button.checkout__button.bold_clone")) && (t = t.querySelector(".cart__footer__value .money")) && (t.innerHTML = e)
	}
	var o = new MutationObserver(function(e) {
			e.forEach(function(e) {
				t(e.target)
			})
		}),
		e = document.querySelectorAll(".cart__footer__value");
	e.forEach(function(e) {
		o.observe(e, {
			childList: !0,
			subtree: !0,
			characterData: !0
		})
	}), e.forEach(t), document.getElementById("drawer-cart-cart-form-terms-checkbox").addEventListener("change", function() {
		document.querySelectorAll("#drawer-cart .drawer__content .drawer__bottom #cart-form button.checkout__button").forEach(function(e) {
			this.checked ? (console.log("checked"), e.disabled = !1) : (console.log("unchecked"), e.disabled = !0)
		}, this)
	}), document.addEventListener("DOMContentLoaded", function() {
		var t = document.querySelector(".selector-wrapper.selector-wrapper--color .radio__legend"),
			o = document.querySelector("form .product__submit .product__submit__buttons"),
			n = document.querySelectorAll('input[name="options[Colour]"]'),
			r = document.querySelector("button.select-popout__toggle"),
			e = document.querySelector(".product__block__buttons"),
			a = document.querySelector(".radio__inputs.radio__inputs--swatch"),
			c = (t && (t.style.display = "none"), o && (o.style.pointerEvents = "none", o.style.opacity = "0.5"), !1),
			u = r ? r.innerText.trim() : "";

		function l() {
			return !r || "Please select" !== r.innerText.trim()
		}

		function i(e, t) {
			var o = e.parentNode.querySelector(".error-message");
			!o && c && ((o = document.createElement("p")).classList.add("error-message"), o.style.color = "red", o.style.marginTop = "10px", o.innerText = t, e.parentNode.appendChild(o))
		}

		function s(e) {
			e = e.parentNode.querySelector(".error-message");
			e && e.remove()
		}

		function d() {
			var e = !0;
			return a && 0 < n.length && (0 < n.length && Array.prototype.some.call(n, function(e) {
				return e.checked
			}) ? s(a) : (e = !1, i(a, "Please select a colour option"))), r && (l() ? s(r) : (e = !1, i(r, "Please make a selection"))), o && (e ? (o.style.pointerEvents = "auto", o.style.opacity = "1") : (o.style.pointerEvents = "none", o.style.opacity = "0.5")), e
		}
		0 < n.length && n.forEach(function(e) {
			e.addEventListener("click", function() {
				t && (t.style.display = "block"), d()
			})
		}), r && setInterval(function() {
			var e = r.innerText.trim();
			e !== u && (u = e, l()) && (s(r), d())
		}, 500), e && e.addEventListener("click", function(e) {
			c = !0, d() || e.preventDefault()
		}), d()
	}), document.addEventListener("DOMContentLoaded", function() {
		var e = document.getElementById("headerVideoLink"),
			t = document.getElementById("headerPopup"),
			o = document.getElementById("sustainable-video");
		e && (e.addEventListener("click", function() {
			t.classList.add("show-video"), t.classList.remove("hide"), o.play()
		}), t.addEventListener("click", function(e) {
			o.contains(e.target) || (t.classList.remove("show-video"), t.classList.add("hide"), o.pause())
		}))
	}), document.addEventListener("DOMContentLoaded", function() {
		var a = [{
			value: "black",
			keys: ["Black", "Nappa Black"]
		}, {
			value: "brown",
			keys: ["Chocolate", "Chestnut", "Bomber", "Chestnut Bomber", "Nappa Bronze"]
		}, {
			value: "beige",
			keys: ["Sand"]
		}, {
			value: "grey",
			keys: ["Slate", "Cloud"]
		}, {
			value: "blue",
			keys: ["Navy", "Country Blue", "Powderpuff", "Aqua", "Lagoon", "Denim"]
		}, {
			value: "pink",
			keys: ["Orchid", "Posy", "Fuschia"]
		}, {
			value: "purple",
			keys: ["Raisin", "Lilac"]
		}, {
			value: "green",
			keys: ["Khaki", "Aqua"]
		}, {
			value: "red",
			keys: ["Jester", "Rust"]
		}, {
			value: "neutral",
			keys: ["Black", "Chocolate", "Chestnut", "Sand", "Khaki"]
		}, {
			value: "pastel",
			keys: ["Cloud", "Posy", "Sherbet", "Powderpuff", "Wattle"]
		}, {
			value: "bright",
			keys: ["Country Blue", "Aqua", "Orchid", "Fuschia", "Lilac"]
		}, {
			value: "leather",
			keys: ["Nappa Black", "Nappa Bronze", "Bomber", "Chestnut Bomber"]
		}, {
			value: "pattern",
			keys: ["Aztec", "Leopard", "Calf"]
		}, {
			value: "limited-edition",
			keys: ["Cloud", "Posy", "Sherbet", "Powderpuff", "Wattle", "Lagoon", "Rust"]
		}];

		function n(r) {
			r.querySelectorAll("input[data-swatch-input]").forEach(function(e) {
				e.addEventListener("change", function() {
					var t, e, o, n;
					t = this.value, e = a.find(function(e) {
						return e.keys.includes(t)
					}), o = e ? e.keys : [t], e = r.querySelectorAll(".product__media"), n = !1, e.forEach(function(e) {
						var t;
						n || (t = e.getAttribute("data-media-src-placeholder") || "", o.some(function(e) {
							return t.toLowerCase().includes(e.toLowerCase())
						}) && (e.scrollIntoView({
							behavior: "smooth",
							block: "center"
						}), n = !0))
					}), n || r.scrollIntoView({
						behavior: "smooth",
						block: "start"
					})
				})
			})
		}
		var r = document.querySelector("[data-product-quickview-ajax]"),
			e = new MutationObserver(function(e) {
				for (var t = 0; t < e.length; t++) {
					var o = e[t];
					"childList" === o.type && 0 < o.addedNodes.length && n(r)
				}
			});
		r && e.observe(r, {
			childList: !0,
			subtree: !0
		}), r && n(r)
	})
}();